import React from 'react';
import styled from 'styled-components';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { ChartCard } from './ChartCard';
import { colors } from '../../theme/tokens';
import { DEMO_TIMESERIES } from './demoData';

const DEMO_DATA = DEMO_TIMESERIES;

const LINE_COLORS = [
  colors.terracotta,
  colors.indigo,
  colors.olive,
  colors.amber
];

export const TimeseriesCard: React.FC = () => (
  <ChartCard
    title="Tendance des articles dans le temps"
    subtitle="12 derniers mois"
  >
    <ChartWrap>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={DEMO_DATA}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--line)" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 11, fill: colors.inkMuted }}
          />
          <YAxis width={40} tick={{ fontSize: 11, fill: colors.inkMuted }} />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="Client A"
            stroke={LINE_COLORS[0]}
            strokeWidth={2}
            dot={{ r: 3 }}
          />
          <Line
            type="monotone"
            dataKey="Concurrent 1"
            stroke={LINE_COLORS[1]}
            strokeWidth={2}
            dot={{ r: 3 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartWrap>
  </ChartCard>
);

const ChartWrap = styled.div`
  margin-top: 8px;
`;
